import { Box, Paper, styled, Typography } from "@mui/material";

export const StyledPageContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  height: "100%",
}));

export const StyledHeaderPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  flexShrink: 0,
}));

export const StyledLoadingContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "80vh",
});

export const StyledTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const StyledGeneratedFormPaper = styled(Paper)(({ theme }) => ({
  height: "100%",
  borderRadius: theme.shape.borderRadius,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
}));

export const StyledTabsContainer = styled(Box)(() => ({
  borderBottom: 1,
  borderColor: "divider",
  flexShrink: 0,
}));

export const StyledTabPanelContainer = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  overflow: "auto",
  padding: theme.spacing(3),
}));
